<div class="flag-holder" (click)="toggle($event);">
  <span>{{getLangName()}}</span>
  @if (getLangFlag()) {
    <img src="../../../../assets/images/flags/{{getLangFlag()}}.svg" />
  }
  <i class="fa" [ngClass]="{'fa-caret-down': !toggleDiv, 'fa-caret-up': toggleDiv}"></i>
</div>
@if (toggleDiv) {
  <div class="flag-list-container">
    <ul>
      @for (lang of languages; track lang) {
        <li (click)="onChange(lang)" [ngClass]="{'selected': lang.locale === selectedLanguage.locale}">
          <span>{{lang.name}}</span>
          <img src="../../../../assets/images/flags/{{lang.locale}}.svg" />
        </li>
      }
    </ul>
  </div>
}